<template>
  <div class="getHeader">
    <van-image class="headerMain"  fit="contain" :src="require('../assets/headerMain.png')" />
    <van-image class="headerH3"  fit="contain" :src="require('../assets/mainHeader.png')" />
    <van-image class="bottomBtn"  fit="contain" :src="require('../assets/bottomBtn.gif')" />
    <!-- <van-image class="headerP1"  fit="contain" :src="require('../assets/headerP1.png')" /> -->
    <div class="cutAllbody">
    <!--   容器   -->
      <div id="view" v-bind:class="{ viewOther: (header3Show||header4Show) }"  v-if="headerSrc!=null" :style="{backgroundImage:
      'url(' +
      headerSrc + ')'}">
      <van-image id="header1" width="200" height="200" :src="require('../assets/header5.png')"
                   v-if="header5Show">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" >头像生成中...</van-loading>
          </template>
        </van-image>
        <van-image id="header1" width="200" height="200" :src="require('../assets/header1.png')"
                   v-if="header1Show">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" >头像生成中...</van-loading>
          </template>
        </van-image>
        <van-image id="header2" width="200" height="200" :src="require('../assets/header2.png')"
                   v-if="header2Show">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" >头像生成中...</van-loading>
          </template>
        </van-image>
        <van-image id="header3" width="200" height="200" :src="require('../assets/header3.png')"
                   v-if="header3Show">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" >头像生成中...</van-loading>
          </template>
        </van-image>
        <van-image id="header4" width="200" height="200" :src="require('../assets/header4.png')"
                   v-if="header4Show">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" >头像生成中...</van-loading>
          </template>
        </van-image>
      </div>
      <div class="AllheaderBody" v-if="ImgShow">
        <van-image id="Allheader" width="200" height="200" :src="imgsrc">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" >头像生成中...</van-loading>
          </template>
        </van-image>
      </div>
    </div>
<!--    <van-image class="headerP2"  fit="contain" :src="require('../assets/headerP2.png')" />-->
    <div class="headerArrBody">
      <van-image fit="cover" :src="require('../assets/minHeader1.png')"
                 @click="SelectHeader(1)" >
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
      <van-image fit="cover" :src="require('../assets/minHeader2.png')"
                 @click="SelectHeader(2)">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
      <van-image fit="cover" :src="require('../assets/minHeader3.png')"
                 @click="SelectHeader(3)">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
      <van-image fit="cover" :src="require('../assets/minHeader4.png')"
                 @click="SelectHeader(4)">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import html2canvas from "html2canvas";
import { Button, Toast, Image, Loading } from 'vant';
export default {
  name: 'getHeader',
  data() {
    return {
      headerSrc:null,  //头像地址
      imgsrc:null,    // 图片地址
      header5Show:true,
      header1Show:false,  // 相框1
      header2Show:false,  // 相框2
      header3Show:false,  // 相框3
      header4Show:false,  // 相框4
      ImgShow:false,  // 图片状态
      wxCode:null,   // code
    };
  },
  mounted: function () {
    WXconfig.prototype.updateAppMessageShareData(); // 分享给盆友
    WXconfig.prototype.onMenuShareAppMessage(); // 分享给盆友
    WXconfig.prototype.onMenuShareTimeline();  // 分享到盆友圈
    WXconfig.prototype.updateTimelineShareData();  // 分享到盆友圈
    const wxcode = window.getPageQuery().code;
    this.wxCode = wxcode;
    this.headerSrc = sessionStorage.getItem('headImgUrl'); // 获取头像地址
    // this.headerSrc = 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKhycujyahiaQ2ULdCVpNFtAyIYmCaJrgRhWXZMsey76Eu0Jl34iavwNhAnEtHTLqBHIYWBgic7rTCcw/0'
    console.info(this.headerSrc)
    console.info(wx)
    this.addImg() // 处理头像生成
  },
  methods:{
    // 生成头像
    screen:function() {
      html2canvas(document.getElementById("view"), {
        useCORS: true,
        backgroundColor: null,
      }).then((canvas) => {
        let canvasImg = canvas.toDataURL("image/png");
        this.header1Show = false;
        this.header2Show = false;
        this.header3Show = false;
        this.header4Show = false;
        this.header5Show = false;

        this.imgsrc = canvasImg;
        this.ImgShow = true;
      });
    },
    SelectHeader:function (type){
      if(type == 1){
        this.header1Show = true;
        this.header2Show = false;
        this.header3Show = false;
        this.header4Show = false;
        this.header5Show = false;

      }else if (type == 2) {
        this.header2Show = true;
        this.header1Show = false;
        this.header3Show = false;
        this.header4Show = false;
        this.header5Show = false;

      }else if (type == 3) {
        this.header3Show = true;
        this.header1Show = false;
        this.header2Show = false;
        this.header4Show = false;
        this.header5Show = false;

      }else if (type == 4) {
        this.header4Show = true;
        this.header1Show = false;
        this.header2Show = false;
        this.header3Show = false;
        this.header5Show = false;

      }
      this.addImg()
    },
    addImg:function (){
      let that = this;
      setTimeout(function(){
        that.screen()
      },200)
    }
  }
};
Vue.use(Button);
Vue.use(Toast);
Vue.use(Image);
Vue.use(Loading);
</script>

<style lang="less" scoped>
.getHeader{
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: url("../assets/IpoPage.png");
  background-size: cover;
  .headerMain{
    width: 85%;
  }
  .headerH3{
    width: 78%;
  }
  .headerP1{
    margin-top: 5px;
    width: 70%;
  }
  .headerArrBody{
    width: 85%;
    display: flex;
    margin-top: 13%;
    padding:15px;
    justify-content:space-around;
    border: 2px dashed #000;
    border-radius: 8px;
    .van-image{
      width: 20%;
    }
  }
  .headerP2{
    width: 40%;
  }
  .bottomBtn{
    margin-top: 50px;
    width: 220px;
  }
}
.cutAllbody{
  width: 200px;
  margin-top: 10%;
  position: relative;
}
#view{
  width: 200px;
  height: 200px;
  margin: 0 auto;
  background-size: cover;
  position: relative;
  //border-radius: 25px;
  overflow: hidden;
  //display: none;
}
.viewOther{
  background-size: 79% !important;
  background-position:center;
}
#header1,#header2,#header3,#header4{
  position: absolute;
  top:0;
  left: 0;
}
.AllheaderBody{
  width: 200px;
  height: 200px;
  top: 0;
  text-align:center;
  position: absolute;
  #Allheader{
    //border-radius: 25px;
    overflow: hidden;
    z-index: 100;
    margin: 0 auto;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/getHeader.vue